module.exports = __webpack_public_path__ + "img/m-golf-after-round.534d584a.png";